import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "src/redux/store";

type PartnerGuestGuardProps = {
  children: React.ReactNode;
};

export default function PartnerGuestGuard({ children }: PartnerGuestGuardProps) {
  const partnerAuth = useSelector((state: RootState) => state.partnerAuth);

  if (partnerAuth.accessToken) {
    return <Navigate to="/partner/home" replace />;
  }

  return <>{children}</>;
}
